// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,


  // for the mobile animation


  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


//*Mobile Menu*//
$( '.c-header__toggle' ).click(function(e) {
  e.preventDefault();

  $('.h-bottom').toggleClass('menu-open');
});

// for the mobile animation

$('.c-header__toggle').click(function(){
  $(this).toggleClass('is-active');
});

// Mobile Drop Menu Primary Nav

$(function () {
  var children = $('#menu-primary-navigation > li > a').filter(function () { return $(this).nextAll().length > 0 ;});
  $('<span class="drop-menu"><i class="fas fa-chevron-down"></i></span>').insertAfter(children);
  $('#menu-primary-navigation .drop-menu').click(function () {
    $(this).next().slideToggle(300);
    return false;
  });
});


// Class on scroll

var viewportWidth = $(window).width();

var scrolls = $('.anchor-top'),
functionscroll   = 10000;
if (viewportWidth >= 300) {
  $(window).scroll(function() {
    var scrollX = $(this).scrollTop();

    if (scrollX >= 100) {
      $(scrolls).delay(functionscroll).addClass('appear');
    } else {
      $(scrolls).removeClass('appear');
    }
  });
}

///////// Smooth scroll to div

$('a[href*="#"]').on('click', function (e) {
  e.preventDefault();

  $('html, body').animate({
    scrollTop: $($(this).attr('href')).offset().top,
  }, 500, 'linear');
});

/// Form action
$('.form-action').click(function(){
  $('.reveal-me').toggleClass('reveal');
});

$('.close').click(function(){
  $('.reveal-me').toggleClass('reveal');
});

/////// Toggle Home for sale order



var scrolled = $('.form-action'),
functionscrolled   = 10000;
if (viewportWidth >= 300) {
  $(window).scroll(function() {
    var scrollX = $(this).scrollTop();

    if (scrollX >= 100) {
      $(scrolled).delay(functionscrolled).addClass('appear');
    } else {
      $(scrolled).removeClass('appear');
    }
  });
}

// Remove emtpy p tags

$('p:empty').remove();

// Property

    // JavaScript to be fired on the home page, after the init JS
    // Slick
    if ($('.js-carousel-gallery').length) {
      $('.js-carousel-gallery').slick({
        arrows: true,
        asNavFor: '.js-carousel-nav',
        dots: true,
        autoplay: false,
        fade: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-right"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-left"></i></button>',
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }

    if ($('.js-carousel-nav').length) {
      $('.js-carousel-nav').slick({
        arrows: false,
        asNavFor: '.js-carousel-gallery',
        autoplay: false,
        dots: false,
        focusOnSelect: true,
        rows: 0,
        slidesToShow: 3,
        slidesToScroll: 1,
      });
    }



// WEBPACK FOOTER //
// ./scripts/main.js